export default __webpack_public_path__ + "static/media/Stack_Pop.d89acf75.gif";